export default [
  {
    "statusName": "Total",
    "status": "Total Appointments",
    "bgColor": "#fbe9f8",
    "totalCount": 0,
    "statusId": [],
    "darkColor": "#f0b0e4",
    "showInEmployees": true
  },
  {
    "statusName": "Confirmed",
    "status": "Confirmed",
    "bgColor": "#cde7fd",
    "totalCount": 0,
    "statusId": [23,24,129,40],
    "darkColor": "#c1e2ff",
    "showInEmployees": true
  },
  {
    "statusName": "Attended",
    "status": "Attended",
    "bgColor": "#bfe5c1",
    "totalCount": 0,
    "statusId": [32, 37,33,48],
    "darkColor": "#b6e5b9",
    "showInEmployees": true
  },
  {
    "statusName": "NotAttended",
    "status": "Not Attended",
    "bgColor": "#ffe0af",
    "totalCount": 0,
    "statusId": [39],
    "darkColor": "#ffe1b4",
    "showInEmployees": true
  },
  {
    "statusName": "Cancelled",
    "status": "Cancelled",
    "bgColor": "#a8ddab",
    "totalCount": 0,
    "statusId": [26,27,28,42],
    "darkColor": "#a8ddab",
    "showInEmployees": true
  },
  {
    "statusName": "NewAppointment",
    "status": "New Appointment",
    "bgColor": "#f8d8d8",
    "totalCount": 0,
    "statusId": [22,29,30,31],
    "darkColor": "#ffcece",
    "showInEmployees": true
  },
];